/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.getAmazonProductVariants

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.getAmazonProductVariants.GetAmazonProductVariantsApi
import features.getAmazonProductVariants.models.RewardResponseModel
import features.getAmazonProductVariants.serializeGetAmazonProductVariantsState



/**
 * Get a reward with external product variants by external product id [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("GetAmazonProductVariantsApi")
class GetAmazonProductVariantsApiJs {

    /**
     * Get a reward with external product variants by external product id
     */
    fun getAmazonProductVariants(
        overrideHeaders: String?, 
        rewardId: Int,
        externalProductId: String
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = GetAmazonProductVariantsApi().getAmazonProductVariants(
            overrideHeaders = decodedOverrideHeaders,
                        rewardId = rewardId,
            externalProductId = externalProductId
        ).toJsonResult<RewardResponseModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeGetAmazonProductVariantsState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        GetAmazonProductVariantsApi().getAmazonProductVariantsState.serializeGetAmazonProductVariantsState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
